// extracted by css-extract-rspack-plugin
export default {"textContainer":"text-container--UzSekeknmCMh7Tmn"};